<template>
    <div>
        <v-radio-group v-model="selectedThresholdForm" row>
            <template>
                <v-row>
                    <v-col cols="6" class="py-2"
                        v-for="(valueDefinition, index) in getCharacteristicAndValues('CUST_MM_STAFFEL_FORM').values"
                        :key="index">
                        <v-radio :label="valueDefinition.description" :value="valueDefinition.value"
                            @change="addCharacterisitc({ characteristic: getCharacteristicAndValues('CUST_MM_STAFFEL_FORM'), valueDefinition: valueDefinition })">
                        </v-radio>
                    </v-col>
                </v-row>
            </template>
        </v-radio-group>

        <div class="mb-6" v-show="showInput">
            <div>
                <div class="body-2 pb-2" style="">{{this.getCharacteristicAndValues("KTU_MM_STAFFEL_HOEHE").description}}</div>
                <v-text-field class="unit-text-field" v-model="ThresholdHeight" dense outlined hide-details  suffix="mm">
                </v-text-field>
            </div>
        </div>

        <div class="mb-4">
            <div class="font-weight-bold mb-3">{{$t('staffelmasse')}}</div>
            <div class="d-flex mb-5">
                <div class="mr-4" style="width:50%;">
                    <div class="body-2 pb-2" style="">{{$t('hohe')}}</div>
                    <v-text-field class="unit-text-field" disabled  :value="parseToGermanFloat(getRegisteredCharacteristicsValue('KTU_MM_STAFFEL_HOEHE', this.measureContext).value.value)"  dense outlined
                        hide-details suffix="mm">
                    </v-text-field>
                </div>
                <div class="" style="width:50%;">
                    <div class="body-2 pb-2" style="">{{$t('breite')}}</div>
                    <v-text-field class="unit-text-field" disabled  :value="parseToGermanFloat(getRegisteredCharacteristicsValue('KTU_MM_STAFFEL_BREITE', this.measureContext).value.value)"  dense outlined
                        hide-details suffix="mm">
                    </v-text-field>
                </div> 
            </div>
            <div class="d-flex">
                <div class="mr-4" style="width:50%;">
                    <div class="body-2 pb-2" style="">{{$t('tiefe')}}</div>
                    <v-text-field class="unit-text-field" disabled  :value="parseToGermanFloat(getRegisteredCharacteristicsValue('KTU_MM_STAFFEL_TIEFE', this.measureContext).value.value)"  dense outlined
                        hide-details suffix="mm">
                    </v-text-field>
                </div>
                <div class="" style="width:50%;">
                    <div class="body-2 pb-2" style="">{{$t('ausfalzung')}}</div>
                    <v-text-field class="unit-text-field" disabled  :value="parseToGermanFloat(getRegisteredCharacteristicsValue('KTU_MM_AUSFAELZUNG', this.measureContext).value.value)"  dense outlined
                        hide-details suffix="mm">
                    </v-text-field>
                </div> 
            </div>
        </div>

        <v-checkbox class="mt-2" :disabled="getNrOfValuesByCharacteristic('CUST_MM_ABSENKDICHTUNG') < 2"
            :input-value="getRegisteredCharacteristicsValue('CUST_MM_ABSENKDICHTUNG', measureContext).value.value === 'JA'"
            :label="'Absenkdichtung ja/nein'"
            @change="checkBoxAddCharacteristic('CUST_MM_ABSENKDICHTUNG');updateabsenkdichtungValues();"></v-checkbox>

    </div>
    <!-- <div>        
        <h1 class="title">Staffel Auswahl</h1>
        <div class="input-group">
            <div class="btn-group btn-group-toggle c-btn-group-toggle" data-toggle="buttons">
                <label v-for="(valueDefinition, index) in getCharacteristicAndValues('CUST_MM_STAFFEL_FORM').values" :key="index" 
                @click="addCharacterisitc({ characteristic: getCharacteristicAndValues('CUST_MM_STAFFEL_FORM'), valueDefinition: valueDefinition });handleRadioSelect(valueDefinition.value)"
                class="btn btn-secondary" :class="{ 'active': checkRadioValue(getCharacteristicAndValues('CUST_MM_STAFFEL_FORM').code, valueDefinition.value) }">
                    <div class="radio-btn">
                        <span></span>
                    </div>
                    <input type="radio" :name="valueDefinition.value" autocomplete="off"> {{ valueDefinition.description }}
                </label>
            </div>
        </div>
        
        <div class="input-group" v-show="showInput">
            <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-default">{{this.getCharacteristicAndValues("KTU_MM_STAFFEL_HOEHE").description}}</span>
            </div>
            <input type="text" v-model="ThresholdHeight" :class="{'form-control' : true}"  aria-label="Default" aria-describedby="inputGroup-sizing-default" value="" >
            <span class="post">mm</span>
        </div>  

        <label class="input-label margin-top">Staffelmaße</label>
        <div class="disabled-inputs">
            <div class="input-group disabled">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-default">Höhe</span>
                </div>
                <input type="text" class="form-control" aria-label="Default" disabled
                    aria-describedby="inputGroup-sizing-default" :value="getRegisteredCharacteristicsValue('KTU_MM_STAFFEL_HOEHE', this.measureContext).value.value">
                <span class="post">mm</span>
            </div>
            <div class="input-group disabled">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-default">Breite</span>
                </div>
                <input type="text" class="form-control" aria-label="Default" disabled
                    aria-describedby="inputGroup-sizing-default" :value="getRegisteredCharacteristicsValue('KTU_MM_STAFFEL_BREITE', this.measureContext).value.value">
                <span class="post">mm</span>
            </div>
            <div class="input-group disabled">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-default">Tiefe</span>
                </div>
                <input type="text" class="form-control" aria-label="Default" disabled 
                    aria-describedby="inputGroup-sizing-default" :value="getRegisteredCharacteristicsValue('KTU_MM_STAFFEL_TIEFE', this.measureContext).value.value">
                <span class="post">mm</span>
            </div>
            <div class="input-group disabled">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-default">Ausfalzung</span>
                </div>
                <input type="text" class="form-control" aria-label="Default" disabled
                    aria-describedby="inputGroup-sizing-default" :value="getRegisteredCharacteristicsValue('KTU_MM_AUSFAELZUNG', this.measureContext).value.value">
                <span class="post">mm</span>
            </div>
        </div>  

        <div class="input-group">
            <div class="btn-group btn-group-toggle c-btn-group-toggle" data-toggle="buttons">
                <label @click="checkBoxAddCharacteristic('CUST_MM_ABSENKDICHTUNG')" class="btn btn-secondary"
                :class="{'active': getRegisteredCharacteristicsValue('CUST_MM_ABSENKDICHTUNG', context).value.value === 'JA', 
                'c-disabled': getNrOfValuesByCharacteristic('CUST_MM_ABSENKDICHTUNG') < 2 }">
                    <div class="check-btn">
                        <span></span>
                    </div>
                    <input type="checkbox" checked autocomplete="off"> Absenkdichtung ja/nein
                </label>
            </div> 
        </div>
                               
    </div> -->
</template>
<script>
    import Vue from 'vue';
    import {
        mapGetters
    } from 'vuex';
    import {
        DoorConfiguration
    } from '../../../configurator/DoorConfiguration';
    import {
        Characteristic,
        ValueDefinition,
        MapCharacteristicAndValue
    } from '../../../configurator/types';
    import {
        mapActions
    } from 'vuex';
    import {parseToGermanFloat, parseFloatFromGermanFloat} from '../../../services/ParserService';

    export default Vue.extend({
        name: 'DoorThreshold',
        props: {

        },
        data() {
            return {
                parseToGermanFloat: parseToGermanFloat,
                parseFloatFromGermanFloat: parseFloatFromGermanFloat,
                measureContext: DoorConfiguration.Measure,
                selectedCharacteristic: {},
                showInput: false,
                validCharacteristicsForInput: ["VS", "BS"],
                context: DoorConfiguration.Measure,
            }
        },
        computed: {
            ...mapGetters('configuratorModule', ['getCurrentDoorConfiguration',
                'getRegisteredCharacteristicsValue'
            ]),
            ...mapGetters('measureModule', ['getCharacteristicAndValues', 'getNrOfValuesByCharacteristic',
                'checkRadioValue', 'getThreshold'
            ]),
            selectedThresholdForm:{
                get: function () {
                    const _this = this;
                    return _this.getRegisteredCharacteristicsValue("CUST_MM_STAFFEL_FORM", this.measureContext)
                        .value.value;
                },
                set: function(newValue){
                    const _this = this;
                    _this.selectedCharacteristic.value = newValue;
                    if (this.validCharacteristicsForInput.includes(_this.selectedCharacteristic.value)) {
                        this.showInput = true;
                        if (_this.selectedThresholdForm === 'VS') {
                            _this.valueAddCharacteristic({
                                characteristicValue: _this.getCharacteristicAndValues(
                                    "KTU_MM_STAFFEL_HOEHE"),
                                value: _this.getThreshold.HeightValueVS
                            });
                        } else if (_this.selectedThresholdForm == 'BS') {
                            _this.valueAddCharacteristic({
                                characteristicValue: _this.getCharacteristicAndValues(
                                    "KTU_MM_STAFFEL_HOEHE"),
                                value: _this.getThreshold.HeightValueBS
                            });
                        }
                    } else {
                        this.showInput = false;
                        _this.valueAddCharacteristic({
                            characteristicValue: _this.getCharacteristicAndValues("KTU_MM_STAFFEL_HOEHE"),
                            value: 0
                        });
                    }

                    let threshold = _this.getThreshold;
                    threshold.HeightValueBS = 0;
                    threshold.HeightValueVS = 0;
                    _this.setThreshold(threshold);
                }
            },
            ThresholdHeight: {
                //getter
                get: function () {

                    const _this = this;
                    let thersholdValue = 0;
                    if (this.selectedThresholdForm === 'VS') {
                        thersholdValue = _this.getThreshold.HeightValueVS;
                    } else if (this.selectedThresholdForm == 'BS') {
                        thersholdValue = _this.getThreshold.HeightValueBS;
                    } else {
                        thersholdValue = _this.getThreshold.HeightValue;
                    }

                    return this.parseToGermanFloat(thersholdValue);
                },
                // setter
                set: function (newValue) {
                    newValue = this.parseFloatFromGermanFloat(newValue);
                    // this.ThresholdHeightValue = newValue;
                    const _this = this;
                    let threshold = _this.getThreshold;
                    if (this.selectedThresholdForm === 'VS') {
                        threshold.HeightValueVS = newValue;
                        threshold.HeightValueBS = 0;
                    } else if (this.selectedThresholdForm == 'BS') {
                        threshold.HeightValueBS = newValue;
                        threshold.HeightValueVS = 0;
                    } else {
                        threshold.HeightValue = 0;
                    }
                    _this.setThreshold(threshold);
                    _this.valueAddCharacteristic({
                        characteristicValue: _this.getCharacteristicAndValues(
                            "KTU_MM_STAFFEL_HOEHE"),
                        value: newValue
                    });
                }
            },
            getTurblattBreite: function() {
                return this.getRegisteredCharacteristicsValue('KTU_MM_TUERBLATTBREITE', this.measureContext).value.value;
            },
            getGehflugelBreite: function() {
                return this.getRegisteredCharacteristicsValue('KTU_MM_GEHFLUEGEL_BREITE', this.measureContext).value.value;
            },
            getTurblattBreiteStehfl: function() {
                return this.getRegisteredCharacteristicsValue('KTU_MM_TUERBLATTBREITE_STEHFLG', this.measureContext).value.value;
            },
            // getTurblattSym: function() {
            //     return this.getRegisteredCharacteristicsValue('CUST_MM_TUER_MASS_SYM', DoorConfiguration.Measure).value.value;
            // }
        },
        watch: {
            getTurblattBreite(getTurblattBreite) {
                this.updateabsenkdichtungValues();
            },
            getGehflugelBreite(getGehflugelBreite) {
                this.updateabsenkdichtungValues();
            },
            getTurblattBreiteStehfl(getTurblattBreiteStehfl) {
                this.updateabsenkdichtungValues();
            },
            // getTurblattSym(getTurblattSym) {
            //     this.updateabsenkdichtungValues();
            // },
        },
        methods: {
            ...mapActions('configuratorModule', ['updateDoorConfiguration']),
            ...mapActions('measureModule', ['addCharacterisitc', 'valueAddCharacteristic',
                'checkBoxAddCharacteristic', 'setThreshold', 'updateabsenkdichtungValues'
            ]),
            // handleRadioSelect(value) {
            //     const _this = this;
            //     _this.selectedCharacteristic.value = value;
            //     if (this.validCharacteristicsForInput.includes(_this.selectedCharacteristic.value)) {
            //         this.showInput = true;
            //         if (_this.selectedThresholdForm === 'VS') {
            //             _this.valueAddCharacteristic({
            //                 characteristicValue: _this.getCharacteristicAndValues(
            //                     "KTU_MM_STAFFEL_HOEHE"),
            //                 value: _this.getThreshold.HeightValueVS
            //             });
            //         } else if (_this.selectedThresholdForm == 'BS') {
            //             _this.valueAddCharacteristic({
            //                 characteristicValue: _this.getCharacteristicAndValues(
            //                     "KTU_MM_STAFFEL_HOEHE"),
            //                 value: _this.getThreshold.HeightValueBS
            //             });
            //         }
            //     } else {
            //         this.showInput = false;
            //         _this.valueAddCharacteristic({
            //             characteristicValue: _this.getCharacteristicAndValues("KTU_MM_STAFFEL_HOEHE"),
            //             value: 0
            //         });
            //     }

            //     let threshold = _this.getThreshold;
            //     threshold.HeightValueBS = 0;
            //     threshold.HeightValueVS = 0;
            //     _this.setThreshold(threshold);
            // },
            initComponentState() {
                const _this = this;
                this.selectedCharacteristic = _this.getRegisteredCharacteristicsValue("CUST_MM_STAFFEL_FORM",
                    this.measureContext).value
                if (this.validCharacteristicsForInput.includes(_this.selectedCharacteristic.value)) {
                    this.showInput = true;
                }
            },
        },
        mounted() {
            this.initComponentState();
        }
    });
</script>
<style scoped>

</style>